{{ row[propertyName] | yesNo }}
